export const fonts = {
	fontFamily: 'DINPro',
	fontFamilyTitle: 'DINPro',
}
